module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/v-y-b9c03cb867f70f0036f2031e834b96ee.svg";